import { Button, ButtonGroup, Grid } from "@mui/material";
import React, { useState } from "react";
import {
  fetchAllRecentTransactionsAsync,
  fetchAllRecentTransactionsFilterAsync,
  selectRecentTransactions,
} from "../features/recentTransactions/recentTransactionSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllFilterTransactionsAsync } from "../features/filterTransactions/filterTransactionSlice";

function Banner() {
  let filter = "";
  const dispatch = useDispatch();
  const recentTransactions = useSelector(selectRecentTransactions);
  const handleClick = (params) => {
    filter = params;
    // console.log(filter);
    if (filter == "all") {
      dispatch(fetchAllRecentTransactionsAsync());
      return;
    }
    dispatch(fetchAllFilterTransactionsAsync(filter));
  };
  return (
    <div class="mx-2 my-0.5 p-2 bg-emerald-500 rounded-lg flex justify-evenly">
      {/* <div class="font-semibold text-lg pb-3"> Recent Transactions </div> */}
      {/* <div class="flex justify-around flex-row"> */}
      <button
        className="card__button bg-[#008556] text-center text-white rounded-xl text-sm py-2 font-medium mx-2 px-2 h-fit"
        onClick={() => handleClick("all")}
      >
        <div class="text-sm">All</div>
      </button>
      <button
        className="card__button bg-[#008556] text-center text-white rounded-xl text-sm py-2 font-medium mx-2 px-2 h-fit"
        onClick={() => handleClick("debit")}
      >
        Debit
      </button>
      <button
        className="card__button bg-[#008556] text-center text-white rounded-xl text-sm py-2 font-medium mx-2 px-2 h-fit"
        onClick={() => handleClick("credit")}
      >
        Credit
      </button>
      {/* </div> */}
    </div>
  );
}

export default Banner;
